import {
    DestinationEvent,
    FormattedEvent,
    transformDestinationEvent,
} from '@eventbrite/event-renderer';
import { sdkRequest } from '@eventbrite/http';
import { useEffect, useState } from 'react';

export function usePromotedEvents(
    pageEventId: string,
    featureFlagEnabled?: boolean,
) {
    featureFlagEnabled = false;
    const [promotedEvents, setPromotedEvents] = useState<Array<FormattedEvent>>(
        [],
    );
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (featureFlagEnabled !== undefined && pageEventId !== undefined) {
            if (featureFlagEnabled) {
                const expansions = [
                    'image',
                    'primary_venue',
                    'ticket_availability',
                    'saves',
                    'primary_organizer',
                ];
                sdkRequest(
                    `/api/v3/destination/events/${pageEventId}/related/?include_promoted_events=true&expand=${expansions.join(
                        ',',
                    )}`,
                ).then(
                    ({
                        promoted_events,
                    }: {
                        promoted_events: Array<DestinationEvent>;
                    }) => {
                        setLoaded(true);
                        setPromotedEvents(
                            promoted_events.map((pe) =>
                                transformDestinationEvent(pe),
                            ),
                        );
                    },
                );
            } else {
                setLoaded(true);
            }
        }
    }, [pageEventId, featureFlagEnabled]);
    return { promotedEvents, loaded };
}
